// src/components/common/RunsLeft.js
import React from "react";
import { Typography } from "@mui/material";

/** "2 of 5 generations left" next to the AI buttons of steps 5 and 7. */
export default function RunsLeft({ summary, step }) {
  const llm = summary?.llm?.[String(step)];
  if (!llm) return null;
  const left = llm.runs_left;
  return (
    <Typography variant="caption" color={left === 0 ? "error" : "text.secondary"} role="status">
      {left} of {llm.limit} AI generations left for this step.
    </Typography>
  );
}
